import { Select } from '@servicecompressionllc/sc-design-system';
import { type PickerVariable } from '../definitionEdit.js';

/** Choose from registered event fields and outputs of earlier steps. */
export const FieldChooser = ({
  value,
  vars,
  onChange,
}: {
  value: string;
  vars: PickerVariable[];
  onChange: (v: string) => void;
}) => {
  if (vars.length === 0) {
    return (
      <p className="min-w-0 flex-1 basis-52 text-xs text-ink-subtle">
        No fields available. Add fields to the registered event or an earlier step with outputs.
      </p>
    );
  }
  const known = vars.some((v) => v.path === value);
  return (
    <Select
      aria-label="Field"
      options={vars.map((v) => ({
        value: v.path,
        label: v.source === 'event' ? v.label : `${v.label} (from ${v.source.step})`,
      }))}
      value={known ? [value] : []}
      placeholder={value && !known ? 'Field unavailable — choose a field' : 'Choose a field'}
      onChange={(sel) => onChange(sel[0] ?? '')}
      className="min-w-0 flex-1 basis-52"
    />
  );
};
